import React, { Component } from 'react';
import axios from 'axios';
import Sidebar from "../../Sidebar";
import { Link } from 'react-router-dom';

class HeadingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pages: [],
    };
  }

  componentDidMount() {
    this.fetchPages();
  }

  fetchPages = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/admin/seo-pages`);
      this.setState({ pages: res.data });
    } catch (err) {
      console.error(err);
    }
  };

  handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this page?");
    if (!confirmDelete) return;
  
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/admin/seo-pages/${id}`);
      alert("Page deleted successfully.");
      this.fetchPages(); // refresh the list
    } catch (err) {
      console.error(err);
      alert("Failed to delete the page.");
    }
  };

  render() {
    const { pages } = this.state;
    return (
        <>
            <div className="sidebar">
            <Sidebar />
            <h2 id="tabler">SEO Pages</h2>
            </div>
            <div style={{ padding: '20px' }} id="tabler1">
                <div className='row'>
                    <div className='col-md-4'>
                        <Link to="/seo-pages/create">
                            {" "}
                            <button type="button" class="btn btn-secondary table-buttons">
                            {" "}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-plus-square-fill"
                                viewBox="0 0 16 16"
                            >
                                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                            </svg>{" "}
                            Create New
                            </button>
                        </Link>
                    </div>
                </div>
                <table class="table" id="table1" style={{ marginTop: '20px' }}>
                <thead>
                    <tr>
                    <th>Page Name</th>
                    <th>Page Type</th>
                    <th>Heading</th>
                    <th>Description</th>
                    <th>Meta Title</th>
                    <th>Meta Description</th>
                    <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {pages.map((page) => (
                    <tr key={page._id}>
                        <td>{page.pageName}</td>
                        <td>{page.pageType}</td>
                        <td dangerouslySetInnerHTML={{ __html: page.heading }} />
                        <td dangerouslySetInnerHTML={{ __html: page.description }} />
                        <td>{page.meta_title}</td>
                        <td>{page.meta_description}</td>
                        <td>
                        <Link to={`/seo-pages/edit/${page._id}`} className="btn btn-sm btn-info">
                            Edit
                        </Link>
                        <button onClick={() => this.handleDelete(page._id)} className="btn btn-sm btn-danger" style={{ marginLeft: '10px' }}>Delete</button>
                        </td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>
        </>
    );
  }
}

export default HeadingComponent;
